import React from 'react';

import services from 'core/services';
import { Icon } from 'framework7-react';
import { withLocale } from 'core/decorators';

import translations from './i18n';
import classes from './styles.module.css';

function Empty(props) {
  const { t } = props;

  services.translation.addModuleResource('empty', translations);

  return (
    <div className={classes.empty}>
      <Icon material="write" />
      {t('no_data')}
    </div>
  )
}

export default withLocale('empty')(Empty);
